import { gql } from '@apollo/client';

export const QUERY_ATTRIBUTES = {
  variables: {
    status: 'no_audio_track',
  },
  fetchPolicy: 'network-only',
};

export const GET_CLIPS = gql`
  query clips($status: TestSessionNotesStatusEnum) {
    clips(status: $status) {
      id
      testSession {
        id
        tester {
          id
          project {
            id
            name
            company {
              id
              name
            }
          }
        }
      }
      createdAt
      updatedAt
      note
    }
  }
`;

export const SEND_CLIP_TO_PROCESS = gql`
  mutation ProcessClip($testSessionNoteId: ID!) {
    processClip(testSessionNoteId: $testSessionNoteId) {
      testSessionNoteId
    }
  }
`;
